import clsx from "clsx";

import RenderIf from "common/components/RenderIf";
import ProfileImage from "common/components/ui/ProfileImage";
import type { ConversationParticipant } from "common/types";

interface GroupAvatarProps {
  participants: ConversationParticipant[];
  size: "sm" | "md";
}

export default function GroupAvatar({ participants, size }: GroupAvatarProps) {
  const membersCount = participants.length;

  return (
    <div
      className={clsx(
        "flex flex-row rtl:space-x-reverse",
        size === "sm" ? "-space-x-4" : "-space-x-5",
      )}
    >
      {participants.slice(0, 2).map((participant) => {
        const { id, picture_url: pictureUrl } = participant;

        return (
          <ProfileImage
            key={id}
            size={size}
            className="rounded-full ring-2 ring-white"
            src={pictureUrl}
            data-testid={`profile-image-${id}`}
          />
        );
      })}

      <RenderIf condition={membersCount > 2}>
        <div
          className={clsx(
            "flex items-center justify-center rounded-full ring-2 ring-white bg-purple-100 text-purple-600",
            size === "sm" ? "size-8 text-xs-bold" : "size-10 text-sm-bold",
          )}
          data-testid="remaining-count"
        >
          +{membersCount - 2}
        </div>
      </RenderIf>
    </div>
  );
}
